var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner mx-auto flex justify-center self-center text-center py-6"},[_c('fingerprint-spinner',{attrs:{"animation-duration":_vm.animationDuration,"size":_vm.size,"color":'#ee577c'}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }